import { notificationsMixin } from './notifications';

/**
 * Mixin odczytu karty przez zdarzenie keyup / oprócz tych w inpucie
 * Zawiera pole:
 * - `cardNumber` - Numer karty który po zatwierdzeniu jest emitowny do store
 * Zawiera metody:
 * - `keyUp` - odczytuje cyfry i dopisuje je do cardNumber/ wysyła do store na enter
 * - `clearCardNumber` - czyści numer karty do pustego stringa
 * - `submitCardNumber` - Wysyła numer karty do store w celu dalszego przetwarzania
 */
export const cardReaderMixin = {
  mixins: [notificationsMixin],
  data() {
    return {
      cardReader: {
        cardNumber: ''
      }
    };
  },
  methods: {
    /**
     *  Czyszczenie wprowadzonego numeru karty
     */
    clearCardNumber() {
      this.cardReader.cardNumber = '';
    },
    /**
     * Wysyłanie karty do store
     */
    submitCardNumber() {
      if (this.cardReaderHandler) {
        this.cardReaderHandler(this.cardReader.cardNumber);
      } else {
        console.warn('Nie znaleziono obsługi czytnika kart');
      }
      this.clearCardNumber();
    },
    /**
     * Przypisanie numeru karty przysłanego z zewnatrz do zmiennej cardNumber
     * @param {number} cn - numer karty przesłany z zewnątrz
     */
    setCardNumber(cn) {
      this.cardReader.cardNumber = cn;
    }
  }
};
